(function () {
  function waitForUserWay(callback) {
    var attempts = 0;
    var maxAttempts = 50;
    var interval = setInterval(function () {
      attempts++;

      if (
        typeof window.UserWay !== "undefined" &&
        window.UserWay.iconVisibilityOff
      ) {
        clearInterval(interval);
        callback();
      }

      if (attempts > maxAttempts) {
        clearInterval(interval);
        console.error(
          "UserWay failed to load after " + maxAttempts * 200 + "ms",
        );
      }
    }, 200);
  }

  document.addEventListener("DOMContentLoaded", function () {
    var trigger = document.getElementById("accessibility-trigger");
    if (!trigger) {
      console.warn("Accessibility trigger element not found");
      return;
    }

    waitForUserWay(function () {
      console.log("UserWay loaded successfully", UserWay);

      if (typeof UserWay.iconVisibilityOff === "function") {
        UserWay.iconVisibilityOff();
      }

      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        if (typeof UserWay.widgetOpen === "function") {
          UserWay.widgetOpen();
        }
      });
    });
  });
})();
